import React, { useMemo } from "react";
import { widthPercentageToDP } from "react-native-responsive-screen";
import {
  VictoryLine,
  VictoryChart,
  VictoryTheme,
  VictoryArea,
  VictoryAxis,
  VictoryLabel,
} from "victory-native";
import moment from "moment";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";
import { Box } from "app/components/common";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import normalize from "app/utils/normalize";

const MEDIUM_LEVEL = 3;

const LABEL_FONT_SIZE = isWebDesktop ? 45 : normalize(10);

const formatData = steps => {
  const results = [
    { x: "s0", y: 0 },
    { x: "s1", y: 0 },
  ];
  let firstWeek = moment();
  let total = 0;
  const now = moment();
  steps
    .filter(step => step.done)
    .map((el, index) => {
      if (index === 0) {
        firstWeek = moment(el.doneDate);
        results[1].y += 1;
        total += 1;
      } else {
        const date = moment(el.doneDate);
        const x = "s" + (date.diff(firstWeek, "week") + 1);
        total += 1;
        const existingWeek = results.find(result => result.x === x);
        if (existingWeek) {
          existingWeek.y += 1;
        } else {
          results.push({ x, y: total });
        }
      }

      return el;
    });
  return results;
};

const CumulativeWeekChart = ({ data, hasAverageLine = false }) => {
  const weekData = useMemo(() => formatData(data), [data]);
  return (
    <Box>
      <VictoryChart
        width={widthPercentageToDP("90%")}
        height={isWebDesktop ? 700 : 300}
        theme={VictoryTheme.material}
        domainPadding={{ y: 1, x: 1 }}
        padding={{
          left: isWebDesktop ? 85 : 25,
          top: 40,
          right: 40,
          bottom: isWebDesktop ? 55 : 25,
        }}
        animate={{
          duration: 250,
        }}
      >
        <VictoryAxis
          style={{
            tickLabels: { fontSize: LABEL_FONT_SIZE },
            axis: { stroke: "#F4F4FB" },
            grid: { stroke: theme.colors["neutral.white"] },
          }}
        />
        <VictoryAxis
          dependentAxis
          style={{
            tickLabels: { fontSize: LABEL_FONT_SIZE },
            axis: { stroke: "#F4F4FB" },
            grid: { stroke: theme.colors["neutral.white"] },
          }}
          crossAxis={false}
          tickFormat={tick => `${Math.round(tick)}`}
        />
        <VictoryArea
          interpolation="monotoneX"
          data={weekData}
          style={{
            axis: {
              stroke: "#F4F4FB",
            },
            grid: {
              stroke: "#F4F4FB",
            },
            data: {
              fill: theme.colors["brand.100"],
              fillOpacity: 1,
              stroke: theme.colors["brand.500"],
              strokeWidth: 2,
            },
          }}
        />
        <VictoryLine
          style={{
            data: {
              stroke: hasAverageLine
                ? theme.colors["system.red.500"]
                : "transparent",
              strokeWidth: hasAverageLine ? 1 : 0,
              strokeDasharray: 4,
            },
          }}
          y={d => MEDIUM_LEVEL}
        />
        {hasAverageLine && (
          <VictoryLabel
            style={{
              fontSize: isWebDesktop ? 45 : 14,
            }}
            text={i18n.t("average-user")}
            datum={{
              x: weekData.length / 2 + 0.5,
              y: MEDIUM_LEVEL + 0.8,
            }}
            textAnchor="middle"
          />
        )}
      </VictoryChart>
    </Box>
  );
};

export default CumulativeWeekChart;
